<template>
  <div
    class="ms-upload-field"
    ref="container"
  >
    <label
      class="label-input"
      :for="uploadFileId"
      ref="labelUpload"
    ><slot /></label>
    <input
      v-show="false"
      @change="onChangeFile"
      type="file"
      v-bind="attrs"
      :accept="acceptKeyCustom"
      ref="fileUpload"
      :multiple="isMultipleCustom"
      :id="uploadFileId"
      :disabled="disabled"
    >
  </div>
</template>

<script>
import { newUuid } from '@/utils/uuid'
import { httpClient } from '@/apis/base'
import BaseForm from '@/views/base/base-form'
import { HttpStatusCode, FileExtention, FileValidation } from '@/common/constant'
import Enumeration from '@/common/enumeration'
import notify from '@/utils/notify'
import getConfigApiUpload from '@/utils/upload-file'

// Control xem trước hay tải xuống 1 định dạng file nào đó
export default {
  name: 'MsUploadField',
  extends: BaseForm,
  inheritAttrs: true,

  emits: ['loadFile', 'uploadedFile', 'update:modelValue', 'loadingFile'],

  props: {
    /** Kiểu kho muốn upload */
    storageType: {
      type: Number,
      default: null
    },
    /** ID của người sở hữu file */
    ownerId: {
      type: String,
      default: null
    },
    // nếu mặc định thì sẽ tự động upload file được chọn lên thư mục tạm
    // nếu bằng false thì đợi gọi hàm upload mới upload
    isAutoUpload: {
      type: Boolean,
      default: false
    },
    /** Đối tượng quản lý file */
    fileManager: {
      type: Object,
      default: null
    },
    /** loại file mà người dùng có thể upload */
    acceptKey: {
      type: String,
      default: null
    },
    /** data binding 2 chiều file */
    modelValue: {
      type: Array,
      default: () => []
    },
    /** Có cho chọn nhiều ko */
    isMultiple: {
      type: Boolean,
      default: true
    },
    // mặc định số file dưới 5
    maxNumFile: {
      type: Number,
      default: FileValidation.MaxNumFile
    },
    // max dung lượng được upload dưới 10MB <=> 10000Kb
    maxSizeFile: {
      type: Number,
      default: FileValidation.MaxSizeFile
    },
    /**
     * Prop phục vụ cho scanner
     */
    scanner: {
      type: Object,
      default: () => {
        return {
          IsExtract: false,
          Subject: null
        }
      }
    },

    disabled: {
      type: Boolean,
      default: false
    },
    /**
     * Có validate thời lượng file video và audio ko
     * Nếu có sẽ bỏ qua validate về dung lượng của 2 loại này
     */
    validateDuration: {
      type: Boolean,
      default: false
    },
    /**
     * Thòi lượng tối đa
     * Đơn vị: giây
     */
    maxDurationFile: {
      type: Number,
      default: FileValidation.maxDurationFile
    },
    /**
     * Hàm vaildate theo nghiệp vụ từng màn trước khi upload file.
     * Nhận 2 tham số đầu vào:
     * - file: <Object> Thông tin file đang được validate
     * - setMessageValidate: <String> thông báo lỗi khi validate fail
     */
    validateCustom: {
      type: Function,
      default: () => true
    },

    clearFilesAfterUpload: {
      type: Boolean,
      default: true
    }

  },

  data () {
    return {
      uploadFileId: '', // id của file
      messageValidate: '', // thông tin lỗi trả về vào đây
      isLoading: false, // đang loading
      listFile: this.modelValue, // danh sách file binding
      listFileValid: [], // danh sách file hợp lệ để upload
      listFileInValid: [] // danh sách file ko hợp lệ
    }
  },

  computed: {
    attrs () {
      return {
        ...this.$attrs
      }
    },
    acceptKeyCustom () {
      if (this.$props.acceptKey?.length > 0) {
        return this.$props.acceptKey
      }
      return FileExtention.ExcerciseUpload
    },
    isMultipleCustom () {
      if (!this.$props.isMultiple) {
        return false
      }
      if (this.$props.maxNumFile === 1) {
        // nếu maxfile là 1 thì cũng ko cho chọn nhiều
        return false
      }
      if (this.$props.maxNumFile === this.listFile.length + 1) {
        return false
      }
      return true
    }
  },

  watch: {
    listFile: {
      handler (newVal, oldVal) {
        this.$emit('update:modelValue', newVal)
      },
      deep: true
    }
  },

  created () {
    this.uploadFileId += newUuid()
  },

  mounted () {
  },

  methods: {
    getContainer () {
      return this.$refs.container
    },

    async onChangeFile (event) {
      const me = this
      me.$emit('loadFile', event)
      if (me.isAutoUpload) {
        me.$commonFn.showMask(me.getContainer())
        const res = await me.uploadFile()
          .catch(err => {
            return Promise.reject(err)
          }).finally(() => {
            me.$commonFn.hideMask(me.getContainer())
          })
        me.$emit('uploadedFile', res, me.listFile, me)
      }
    },

    setMessageValidate (message) {
      this.messageValidate = message
    },

    /**
     * @description set giá trị cho listFile
     */
    setListFile (files) {
      if (Array.isArray(files)) {
        this.listFile = files
      }
    },

    async validate () {
      const me = this
      let isValid = true
      me.listFileValid = []
      me.listFileInValid = []
      me.messageValidate = ''

      if (me.$refs.fileUpload?.files?.length > 0) {
        for (let i = 0; i < me.$refs.fileUpload.files.length; i++) {
          const file = me.$refs.fileUpload.files[i]
          if (me.validateExtension(file) && me.validateMaxNumberFile() && me.validateFileSize(file) &&
          await me.validateMaxDuration(file) && (!me.validateCustom || me.validateCustom(file, me.setMessageValidate.bind(this)))) {
            me.listFileValid.push(file)
          } else {
            me.listFileInValid.push(file)
          }
        }
        if (me.listFileValid.length === 0) {
          isValid = false
        }
      } else {
        isValid = false
      }
      return isValid
    },

    /**
     * kiểm tra dung lượng có vượt quá dung lượng cho phép ko
     */
    validateFileSize (file) {
      const me = this
      const isValid = me.$props.maxSizeFile * 1000 > file.size
      if (!isValid) {
        me.messageValidate = me.$t('Controls.UploadField.SizeLimit') + ' ' + me.$props.maxSizeFile / 1000 + ' MB'
      }
      return isValid
    },

    /**
     * Số file thỏa mãn đủ rồi hoặc số file có sẵn đủ rồi
     */
    validateMaxNumberFile () {
      const me = this
      const isValid = (me.listFile?.length || 0) + (me.listFileValid?.length || 0) < me.$props.maxNumFile

      if (!isValid) {
        me.messageValidate = me.$t('Controls.UploadField.NumberFileLimit')
      }
      return isValid
    },

    /**
     * kiểm tra xem đuôi file có hợp lệ không
     */
    validateExtension (file) {
      const me = this
      let isValid = true
      const extensionFile = me.getFileExtension(file.name)
      if (extensionFile === '' || !me.acceptKeyCustom.includes(extensionFile)) {
        isValid = false
        me.messageValidate = me.$t('Controls.UploadField.ExtensionNotAllow')
      }
      return isValid
    },

    /**
     * Lấy file Extension theo file name
     */
    getFileExtension (fileName) {
      const parts = fileName?.split('.')
      let extensionFile = parts.length > 1 ? parts.pop() : ''
      extensionFile = '.' + extensionFile.toLowerCase()

      return extensionFile
    },

    /**
     * validate thời lượng file
     */
    async validateMaxDuration (file) {
      const me = this
      const fileExtension = me.getFileExtension(file.name)

      if (!me.validateDuration || !FileExtention.AudioAndVideo.includes(fileExtension)) {
        return true
      }

      const duration = await me.getVideoDuration(file)
      const isValid = duration <= me.maxDurationFile

      if (!isValid) {
        me.messageValidate = me.$t('Controls.UploadField.FileDurationTooLong')
      }
      return isValid
    },

    /**
     * Thêm file xong thì xóa file trong control đi
     * Cập nhật thông tin file vào fileManager
     */
    afterUploadFile (res) {
      const me = this
      me.$refs.fileUpload.value = ''
      me.clearFilesAfterUpload && (me.listFile = [])
      if (res?.Code === HttpStatusCode.OK && res.Data?.length > 0) {
        for (let i = 0; i < res.Data.length; i++) {
          const file = res.Data[i]
          if (me.$props.isAutoUpload) {
            file.StorageType = me.$props.storageType
          }
          me.listFile.push(file)

          if (me.$props.fileManager != null && Array.isArray(me.$props.fileManager)) {
            me.$props.fileManager.push(file)
          }
        }
      }
    },

    /**
     */
    afterExtractFile (res) {
      const me = this
      me.$refs.fileUpload.value = ''
    },

    async uploadFile () {
      const me = this
      const isValid = await me.validate()
      if (isValid) {
        const configs = getConfigApiUpload(
          {
            IsExtract: me.$props.scanner?.IsExtract,
            OwnerId: me.$props.ownerId,
            StorageType: me.$props.isAutoUpload ? Enumeration.StorageType.Temp : me.$props.storageType,
            Subject: me.$props.scanner?.Subject,
            Files: me.listFileValid
          })
        console.log(configs)
        me.isLoading = true
        me.$emit('loadingFile', true)
        const data = await httpClient.requestAsync(configs)
          .catch((err) => {
            return Promise.reject(err)
          })
          .finally(() => {
            me.isLoading = false
            me.$emit('loadingFile', false)
          })
        const isNoErrUpload = me.checkAndRemoveErrorUploadItem(data)
        if (!isNoErrUpload) {
          notify.showError({
            message: me.$t('Controls.UploadField.UploadFail')
          })
        }

        if (me.$props.scanner?.IsExtract) {
          me.afterExtractFile(data)
        } else {
          me.afterUploadFile(data)
        }
        return data
      } else {
        me.$refs.fileUpload.value = ''
        notify.showError({
          message: me.messageValidate
        })
        return Promise.reject(me.messageValidate)
      }
    },

    checkAndRemoveErrorUploadItem (res) {
      let isValid = true
      if (res?.Code === HttpStatusCode.OK && res.Data?.length > 0) {
        const datas = res.Data
        res.Data = []
        for (let i = 0; i < datas.length; i++) {
          if (datas[i].Success) {
            res.Data.push(datas[i])
          } else {
            isValid = false
          }
        }
      }
      return isValid
    },

    clearModelValue () {
      const me = this
      me.listFile = []
      me.$emit('update:modelValue', [])
    },

    onUpoadFile () {
      this.$refs.fileUpload.click()
    },

    /**
     * @author PVThang
     * @description lấy duration của file video
     */
    getVideoDuration (file) {
      return new Promise((resolve) => {
        const video = document.createElement('video')

        video.preload = 'metadata'
        video.onloadedmetadata = function () {
          window.URL.revokeObjectURL(video.src)
          const duration = video.duration

          console.log(duration)
          resolve(duration || 0)
        }
        video.src = URL.createObjectURL(file)
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.label-input{
    cursor: pointer;
}
</style>
